import request from '@/utils/request';
import { status } from 'nprogress';

export function RechargeAPI() {
	return {
		//充值模板列表
		getRechargeList: (params) => {
			return request({
				url: '/admin/recharge/template/list',
				method: 'get',
				params,
			});
		},
    getvipList: params => {
      return request ({
        url: '/admin/goods_vip/list',
        method: 'get',
        params,
      });
    },
		//vip详情
		getGoods_vipInfoDetil: (params) => {
			return request({
				url: '/admin/goods_vip/info?id=' + params,
				method: 'get',
				data: params,
			});
		},
		// 选择模板
		Rechargetmpla: (params) => {
			return request({
				url: `/admin/recharge/template/select?movie_id=${params}`,
				method: 'get',
			});
		},
		//状态
		statusRecharge: (data) => {
			return request({
				url: '/admin/recharge/template/status',
				method: 'post',
				data,
			});
		},
		//新增充值列表
		AddRecharge: (data) => {
			return request({
				url: '/admin/recharge/template/edit',
				method: 'post',
				data,
			});
		},
		//vip删除
		getGoods_vipDel: (params) => {
			return request({
				url: '/admin/goods_vip/del?id=' + params,
				method: 'post',
			});
		},
		//充值模板添加
		getvipedit: (params) => {
			return request({
				url: '/admin/goods_recharge/edit',
				method: 'post',
				params,
			});
		},
		//充值模版详情
		goods_rechargeinfo: (params) => {
			return request({
				url: '/admin/recharge/template/info?id=' + params,
				method: 'get',
			});
		},
	};
}
